import { createRoot } from 'react-dom/client'
import './index.css'
import SEO from './components/SEO.jsx'
import { logo as APP_LOGO } from './constant'
import Admin from './Admin.js'
import FirstTimeSetup from './Pages/FirstTimeSetup.jsx'
import { RecoilRoot } from 'recoil'

const isFirstTimeSetup = (typeof window !== 'undefined') && window.location.pathname.toLowerCase().includes('/admin/firsttimesetup');

// Set favicon/apple-touch icon dynamically from brand logo
try {
  const setIcon = (rel) => {
    let link = document.querySelector(`link[rel='${rel}']`);
    if (!link) { link = document.createElement('link'); link.rel = rel; document.head.appendChild(link); }
    link.href = APP_LOGO;
  };
  if (APP_LOGO) {
    setIcon('icon');
    setIcon('apple-touch-icon');
  }
} catch {}

const rootEl = document.getElementById('root');
createRoot(rootEl).render(
  <RecoilRoot>
    <SEO />
    {isFirstTimeSetup ? <FirstTimeSetup /> : <Admin />}
  </RecoilRoot>
)

// Remove initial loader once React is mounted
try {
  const gl = document.getElementById('global-loader');
  if (gl && gl.parentNode) gl.parentNode.removeChild(gl);
} catch {}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
